// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2xdoS","title":"Images90_title__1nhLT","images":"Images90_images__BJO-d"};